import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

class SchedulerContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            variables: this.props.variables || {},
            onChange: this.props.onChange || function () { },
        }
        this.handleFormChange = this.handleFormChange.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            variables: nextProps.variables || {},
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                </div>
            </div>
        );
    }
}

export default injectIntl(SchedulerContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/scheduler/input.component.jsx